// extracted by mini-css-extract-plugin
export var attribution = "BlockQuote-module--attribution--04784";
export var blockquote = "BlockQuote-module--blockquote--89ae9";
export var imageContainer = "BlockQuote-module--imageContainer--f0ba3";
export var quoteContent = "BlockQuote-module--quoteContent--b94d7";
export var textContainer = "BlockQuote-module--textContainer--a497b";